import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import "./NotesIndex.css";

import NoteContainer from "./NoteContainer/NoteContainer";
import Sidebar from "./Sidebar/Sidebar";
import Navbar from "components/Navbars/AuthNavbar";
import Footer from "components/Footers/Footer";
import BASE_URL from "components/BaseUrl/apiConfig";
import BlockUiOverlay from 'components/Expense/BlockUiOverlay';

function NotesIndex() {

    const [notes, setNotes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showSidebar, setShowSidebar] = useState(true);
    //get userid form loca storage
    const storedUserData = localStorage.getItem('userData');
    let userId = '';

    if (storedUserData) {
        const userData = JSON.parse(storedUserData);
        userId = userData.userId;
    }

    const fetchNotes = () => {
        //setLoading(true)
        fetch(`${BASE_URL}/api/StickyNotes/GetAllStickyNotes?userid=${userId}`)
            .then(response => response.json())
            .then(data => {
                setNotes(data); // Update state with fetched data
                setLoading(false)
            })
            .catch(error => {
                setLoading(false)
                console.error("Error fetching notes:", error);
            });
    };

    useEffect(() => {
        fetchNotes(); // Fetch notes when component mounts
    }, []);


    //here is the code of insert a new card
    const addNote = async (color) => {

        //setLoading(true)
        // Check if the last note has text content
        const lastNote = notes[notes.length - 1];
        if (lastNote && (lastNote.text.trim() === "" && lastNote.title.trim() === "")) {
            setShowSidebar(false);
            setLoading(false);
            //alert("Please add both title and text to the previous note before adding a new one.");
            return;
        }
        

        try {
            const response = await fetch(`${BASE_URL}/api/StickyNotes/InsertStickyNotes`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    stickyNotesId: 0,
                    title: "",
                    text: "",
                    userId: userId,
                    color: color,
                })
            });
            if (response.ok) {
                setLoading(false);
                const responseData = await response.json();
                setNotes(prevNotes => [...prevNotes, responseData]); // Assuming API returns the added note
                fetchNotes();
                setNotes({
                    text: ''
                });
                setShowSidebar(false);

            } else {
                setLoading(false);
                throw new Error("Failed to add note");
            }
        } catch (error) {
            setLoading(false);
            console.error("Error adding note:", error);
        }
    };

    //here is the code of the update text on the card
    const updateText = async (notetitle, text, id, color) => {
        try {
            const response = await fetch(`${BASE_URL}/api/StickyNotes/InsertStickyNotes`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    stickyNotesId: id,
                    title: notetitle,
                    text: text,
                    userId: userId,
                    color: color // Assuming color is also needed for the new note
                })
            });
            if (response.ok) {

                setShowSidebar(true);
                fetchNotes();
                const tempNotes = [...notes];
                const index = tempNotes.findIndex((item) => item.id === id);
                if (index < 0)
                    tempNotes[index].text = text;
                setNotes(tempNotes);
                setNotes({
                    text: ''
                });
                return;
            } else {
                throw new Error("Failed to update note");
            }
        } catch (error) {
            console.error("Error updating note:", error);
        }
    };


    //here is the code of the delete card
    const deleteNote = async (id) => {
        // Show a SweetAlert confirmation before deleting
        Swal.fire({
            title: 'Confirmation',
            text: `Are you sure want to delete?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes',
        }).then((result) => {
            if (result.isConfirmed) {
                // User clicked "Yes, delete it!" - Perform the delete API call
                fetch(`${BASE_URL}/api/StickyNotes/DeleteStickyNotes?stickyNotesId=${id}`, {
                    method: 'Post',
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            Swal.fire('Deleted!', 'Note deleted successfully.', 'success');
                            // Create a new array excluding the deleted note
                            const updatedNotes = notes.filter(note => note.stickyNotesId !== id);
                            // Update state with the new array
                            setNotes(updatedNotes);
                        } else {
                            // Handle delete failure (show error message, etc.)
                            Swal.fire('Error!', 'Note deletion failed.', 'error');
                        }
                    })
                    .catch(error => console.error('Error deleting user:', error));
            }
        });
    };


    return (
        <>
            <Navbar />
            <BlockUiOverlay visible={loading} />
            <div className="cust-div">
                <div className="App  p-4">
                    {showSidebar && ( // Conditionally render sidebar
                        <Sidebar addNote={addNote} notes={notes} />
                    )}
                    <NoteContainer
                        notes={notes}
                        // notetitle={notetitle}
                        deleteNote={deleteNote}
                        updateText={updateText}
                    />
                </div>
            </div>
            <Footer />
        </>
    );
}

export default NotesIndex;
